import styled, { css } from 'styled-components';

import { ContainerProps, CustomProps } from './types';

export const Link = styled.a`
	all: unset;
	cursor: pointer;
	position: relative;
	overflow: hidden;
`;

export const Container = styled.div<ContainerProps>`
	${({ miniBannerBgColor }) => css`
		background: ${miniBannerBgColor};
		border-radius: 1.2rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	`}
`;
export const MiniBannerContent = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: 2rem;
`;

export const Title = styled.p`
	${({ theme }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.bold};
		font-size: 2rem;
		color: ${theme.colors.white};

		@media (min-width: 140rem) {
			font-size: 2.4rem;
		}
	`}
`;

export const Subtitle = styled.p`
	${({ theme }) => css`
		padding-top: 0.8rem;
		margin: 0;
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.bold};
		color: ${theme.colors.yellowPrimary};

		@media (min-width: ${theme.breakpoints.desktop}) {
			display: none;
		}
	`}
`;

export const Image = styled.div`
	${({
		theme,
		miniBannerAutoMobile,
		miniBannerAutoDesktop,
	}: CustomProps) => css`
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		border-top-right-radius: 12px;
		border-bottom-right-radius: 12px;
		background-image: url(${miniBannerAutoMobile});
		min-width: 9.7rem;
		height: 11rem;
		@media (min-width: ${theme.breakpoints.ultraWide}) {
			background-image: url(${miniBannerAutoDesktop});
			width: 12.3rem;
			height: 13.7rem;
		}
	`}
`;
